var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_5868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 27.6667C31.1111 30.7609 29.8819 33.7283 27.694 35.9162C25.5061 38.1042 22.5386 39.3333 19.4444 39.3333C16.3503 39.3333 13.3828 38.1042 11.1949 35.9162C9.00694 33.7283 7.77778 30.7609 7.77778 27.6667C7.77778 24.5725 9.00694 21.605 11.1949 19.4171C13.3828 17.2292 16.3503 16 19.4444 16C22.5386 16 25.5061 17.2292 27.694 19.4171C29.8819 21.605 31.1111 24.5725 31.1111 27.6667ZM62.2222 27.6667C62.2222 29.1988 61.9205 30.7158 61.3342 32.1313C60.7478 33.5468 59.8885 34.8329 58.8051 35.9162C57.7218 36.9996 56.4357 37.859 55.0202 38.4453C53.6047 39.0316 52.0876 39.3333 50.5556 39.3333C49.0235 39.3333 47.5064 39.0316 46.0909 38.4453C44.6754 37.859 43.3893 36.9996 42.306 35.9162C41.2226 34.8329 40.3633 33.5468 39.777 32.1313C39.1907 30.7158 38.8889 29.1988 38.8889 27.6667C38.8889 24.5725 40.118 21.605 42.306 19.4171C44.4939 17.2292 47.4614 16 50.5556 16C53.6497 16 56.6172 17.2292 58.8051 19.4171C60.9931 21.605 62.2222 24.5725 62.2222 27.6667ZM46.3944 70.4444C46.5733 69.1728 46.6667 67.8778 46.6667 66.5556C46.6757 60.4456 44.6201 54.5117 40.8333 49.7167C43.7892 48.0101 47.1423 47.1116 50.5554 47.1116C53.9686 47.1116 57.3216 48.01 60.2776 49.7165C63.2335 51.4231 65.6881 53.8776 67.3948 56.8335C69.1014 59.7894 69.9999 63.1424 70 66.5556V70.4444H46.3944ZM19.4444 47.1111C24.6014 47.1111 29.5472 49.1597 33.1937 52.8063C36.8403 56.4528 38.8889 61.3986 38.8889 66.5556V70.4444H0V66.5556C0 61.3986 2.04861 56.4528 5.69515 52.8063C9.34169 49.1597 14.2875 47.1111 19.4444 47.1111Z",
    fill: "white",
    fillOpacity: 0.28
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_5868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon04);
export default __webpack_public_path__ + "static/media/card-icon-04.33de8f5327244efd268e162cd4713259.svg";
export { ForwardRef as ReactComponent };